import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const SignupPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();


  const handleEmailSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage('');

    const { error } = await supabase.auth.signUp({
      email: email,
      password: password,
    });

    if (error) {
      setError(error.message);
    } else {
      setMessage('Registration successful! Please check your email for a confirmation link.');
      navigate('/onboarding', {replace: true});
    }
    setLoading(false);
  };

  return (
    <section className="section is-fullheight has-background-light">
      <div className="container">
            <div className="box p-5" style={{width: '400px', margin: 'auto'}}>
              <h1 className="title has-text-centered mb-5">Create Account</h1>
              {error && (
                <div className="notification is-danger">
                  <button className="delete" onClick={() => setError(null)}></button>
                  {error}
                </div>
              )}
              {message && (
                <div className="notification is-success">
                  <button className="delete" onClick={() => setMessage('')}></button>
                  {message}
                </div>
              )}
              <form onSubmit={handleEmailSignup}>
                <div className="field mb-4">
                  <label className="label" htmlFor="email-signup">Email</label>
                  <div className="control has-icons-left">
                    <input
                      className="input"
                      type="email"
                      id="email-signup"
                      placeholder="e.g. alex@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-envelope"></i>
                    </span>
                  </div>
                </div>

                <div className="field mb-4">
                  <label className="label" htmlFor="password-signup">Password</label>
                  <div className="control has-icons-left">
                    <input
                      className="input"
                      type="password"
                      id="password-signup"
                      placeholder="********"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={loading}
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-lock"></i>
                    </span>
                  </div>
                </div>

                <div className="field mb-4">
                  <button
                    className={`button is-link is-fullwidth ${loading ? 'is-loading' : ''}`}
                    type="submit"
                    disabled={loading || error != null}
                  >
                    <span className="icon is-small is-left">
                      <i className="fas fa-user-plus"></i>
                    </span>
                    <span>Create Account</span>
                  </button>
                </div>
              </form>

              <p className="has-text-centered mt-5">
                Already have an account? <Link to="/login">Log In</Link>
              </p>
            </div>
          </div>
    </section>
  );
};

export default SignupPage;